module.exports = __webpack_public_path__ + "static/media/slot-0.3637a219.png";